/// Appelé uniquement sur la page de creation des listes mariages, pacs et cadeaux
/// /liste-cadeaux/creation-liste-[TypeList]

class Creation extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize(idFormulaire) {
		let self = this;

		super.initialize();

		const form = new Formulaire();
		form.initialize(idFormulaire);

		super._datepickerFormatter();

		document.forms[idFormulaire].addEventListener('submit', (event) => {
			let isValid = self._samePassword(self.config.pwd1, self.config.pwd2, 'ErrorPwd');

			if (!isValid || !document.getElementById(idFormulaire).checkValidity()) {
				event.preventDefault();
			}
		});
	}

	_samePassword(password1, password2, error) {

		let inputs = [password1, password2];

		for (const input of inputs) {
			input.addEventListener('focusin', function () {
				document.getElementById(error).innerText = '';
			})
		}

		if (password1.value !== password2.value) {
			if (password1.value !== '' && password2.value != '') {
				document.getElementById(error).innerText = 'Les deux mots de passe ne sont pas identiques.';
			}
			return false;
		} else {
			return true;
		}

	}
}